export default __webpack_public_path__ + "static/media/jpy.8ded3e2d.png";